import { forwardRef } from 'react';
import { IPassword } from './password.models';
import { usePassword } from './password.hook';
import * as S from './password.style';
import { Input } from '../Input';

export const Password = forwardRef<HTMLInputElement, IPassword>(
  ({ hidden, label, onChange, onFocus, style, styled, ...rest }, ref) => {
    const { handleChange, handleFocus, id, refCallback, svg, toggleClick, type } = usePassword({
      onChange,
      onFocus,
      ref,
    });

    return (
      <S.Container style={style} styled={styled} hidden={hidden}>
        <Input
          {...rest}
          aria-autocomplete="none"
          aria-controls={id}
          btnProps={{
            'aria-controls': id,
            onClick: toggleClick,
            tabIndex: -1,
          }}
          label={label}
          onChange={handleChange}
          onFocus={handleFocus}
          ref={refCallback}
          svg={svg}
          type={type}
        />
      </S.Container>
    );
  }
);

